import { IReduxAction } from '~/services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ROWS_COUNT,
  SET_ORDER,
  SET_ORDERBY,
  GET_LIST_ALL_CHECKLIST_REPORTS_SUCCESS,
  SEARCH,
  GET_MODAL_QUESTIONS_SUCCESS,
  SET_LOADING_SELECTS,
  GET_ALL_SELECTS_SUCCESS
} from './client-report-checklist-constants';
import {
  SET_ORDER_ANSWER,
  SET_ORDERBY_ANSWER,
  SET_PAGE_ANSWER,
  SET_ROWS_COUNT_ANSWER,
  SET_ROWS_PER_PAGE_ANSWER
} from './client-report-modal-answers-constants';

const INITIAL_STATE = {
  loadingData: false,
  loadingSelects: false,
  list: {
    hasRemotePagination: true,
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    order: 'desc',
    orderBy: 'createdAt',
    selects: null
  },
  modalData: {
    list: {
      hasRemotePagination: true,
      allRows: [],
      rows: [],
      rowsCount: 0,
      page: 0,
      rowsPerPage: 10,
      rowsPerPageOptions: [10, 25, 50, 100],
      order: 'desc',
      orderBy: 'createdAt'
    },
    loadingModalData: false
  }
};

const clientReportChecklist = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_SELECTS: {
      return {
        ...state,
        loadingSelects: action.loading
      };
    }

    case GET_LIST_ALL_CHECKLIST_REPORTS_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.payload?.checklistReport,
          allRows: action.payload?.checklistReport,
          rowsCount: action.payload?.rowsCount ?? state?.list?.rowsCount
        }
      };
    }

    case GET_MODAL_QUESTIONS_SUCCESS: {
      return {
        ...state,
        modalData: {
          list: {
            ...state.modalData.list,
            rows: action.payload?.answersData,
            allRows: action.payload?.answersData,
            rowsCount: action.payload?.count ?? state?.modalData?.list?.rowsCount
          }
        }
      };
    }

    case GET_ALL_SELECTS_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          selects: { ...action.payload }
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ROWS_COUNT: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsCount: action.rowsCount
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    case SEARCH: {
      const { queryString } = action;

      const results =
        queryString !== ''
          ? state.list.allRows.filter(
              (item: any) =>
                item?.questionary?.userExternalCode?.toString().startsWith(queryString.toLowerCase()) ||
                item?.questionary?.userExternalCode?.includes(queryString) ||
                item?.questionary?.user?.name?.toString().startsWith(queryString.toLowerCase()) ||
                item?.questionary?.user?.name?.includes(queryString) ||
                item?.questionary?.questionaryName?.toString().startsWith(queryString.toLowerCase()) ||
                item?.questionary?.questionaryName?.includes(queryString)
            )
          : state.list.allRows;

      return {
        ...state,
        list: {
          ...state.list,
          rows: [...results]
        }
      };
    }

    case SET_PAGE_ANSWER: {
      return {
        ...state,
        modalData: {
          list: {
            ...state.modalData.list,
            page: action.page
          }
        }
      };
    }

    case SET_ROWS_PER_PAGE_ANSWER: {
      return {
        ...state,
        modalData: {
          list: {
            ...state.modalData.list,
            rowsPerPage: action.rowsPerPage
          }
        }
      };
    }

    case SET_ROWS_COUNT_ANSWER: {
      return {
        ...state,
        modalData: {
          list: {
            ...state.modalData.list,
            rowsCount: action.rowsCount
          }
        }
      };
    }

    case SET_ORDER_ANSWER: {
      return {
        ...state,
        modalData: {
          list: {
            ...state.modalData.list,
            order: action.order
          }
        }
      };
    }

    case SET_ORDERBY_ANSWER: {
      return {
        ...state,
        modalData: {
          list: {
            ...state.modalData.list,
            orderBy: action.orderBy
          }
        }
      };
    }

    default:
      return state;
  }
};

export default clientReportChecklist;
